<template>
    <div class="bg-white py-4 mt-3">
        <div class="container">
            <h1>{{msg}}</h1>
            <!-- Table V1 Start-->
            <table class="table table-borderless table-week">
                <thead>
                <tr>
                    <th scope="col">Personen</th>
                    <th scope="col">Mo</th>
                    <th scope="col">Di</th>
                    <th scope="col">Mi</th>
                    <th scope="col">Do</th>
                    <th scope="col br-1">Fr</th>
                    <th scope="col">Sa</th>
                    <th scope="col">So</th>
                    <th scope="col">***</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row">3</th>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                </tr>
                <tr>
                    <th scope="row">1</th>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                </tr>
                <tr>
                    <th scope="row">1</th>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                </tr>

                <tr>
                    <th scope="row">2</th>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                </tr>

                <tr>
                    <th scope="row">0</th>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                </tr>

                <tr>
                    <th scope="row">1</th>
                    <td><div class="checkbox checkbox--circle"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                    <td><div class="checkbox"></div></td>
                </tr>
                </tbody>
            </table>
            <!-- Table V1 Ends-->

            <!-- Table V2 Start-->
            <div class="table-groups">
                <table class="table table-borderless table-month">
                    <thead class="table-month__heading">
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    </tbody>
                </table>

                <table class="table table-borderless table-month">
                    <thead class="table-month__heading">
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    </tbody>
                </table>

                <table class="table table-borderless table-month">
                    <thead class="table-month__heading">
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    </tbody>
                </table>

                <table class="table table-borderless table-month">
                    <thead class="table-month__heading">
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    </tbody>
                </table>

                <table class="table table-borderless table-month">
                    <thead class="table-month__heading">
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox checkbox--circle"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    <tr>
                        <td><div class="checkbox checkbox--circle"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>
                    </tbody>
                </table>

            </div>
            <!-- Table V2 Ends-->

            <!-- Legende Start -->
                <div class="legend">
                    <div class="row">

                        <div class="col-12 col-lg-3">
                            <div class="legend__item">
                                <span class="checkbox checkbox--circle"></span>
                                <span class="legend__text">Hat Dienst</span>
                            </div>
                            <div class="legend__item">
                                <span class="checkbox checkbox--circle--half"></span>
                                <span class="legend__text">Hat teilweise Dienst</span>
                            </div>
                            <div class="legend__item">
                                <span class="checkbox checkbox--blue"></span>
                                <span class="legend__text">Absenz</span>
                            </div>
                        </div>

                        <div class="col-12 col-lg-3">
                            <div class="legend__item">
                                <span class="checkbox checkbox--circle--center"></span>
                                <span class="legend__text">Hat Dienst übernommen</span>
                            </div>
                            <div class="legend__item">
                                <span class="checkbox checkbox--circle--yellow"></span>
                                <span class="legend__text">Hat Dienst abgegeben</span>
                            </div>
                            <div class="legend__item">
                                <span class="checkbox checkbox--pink-border"></span>
                                <span class="legend__text">Feiertag</span>
                            </div>
                        </div>

                        <div class="col-12 col-lg-3">
                            <div class="legend__item">
                                <span class="checkbox checkbox--triangle-down"></span>
                                <span class="legend__text">Hat Dienst abgeben</span>
                            </div>
                            <div class="legend__item">
                                <span class="checkbox checkbox--half--left"></span>
                                <span class="legend__text">Hat Dienst teilweise abgeben</span>
                            </div>
                        </div>

                        <div class="col-12 col-lg-3">
                            <div class="legend__item">
                                <span class="checkbox checkbox--triangle-right"></span>
                                <span class="legend__text">Will Dienst tauschen</span>
                            </div>
                            <div class="legend__item">
                                <span class="checkbox checkbox--half--bottom"></span>
                                <span class="legend__text">Hat Dienst teilweise tauschen</span>
                            </div>
                        </div>

                    </div>
                </div>
            <!-- Legende Ends -->

            <!-- Table Tabs Start-->
            <TableTabs></TableTabs>
            <!-- Table Tabs Ends-->


        </div>
    </div>
</template>

<script>
    import TableTabs from '@/components/TableTabs'
    export default {
        name: "Matrix",
        components: {
            TableTabs
        },
        data() {
            return {
                msg: 'Calender'
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables";

    %border-right {
        border-right: 1px solid #ddd;
    }

    .table {
        &-groups {
            display: flex;
            overflow-x: scroll;
        }
        &-week {
            thead {
                color: $alert-blue;
            }
        }

        &-month {
            &__heading {
               > tr th:nth-child(5n) {
                   @extend %border-right;
               }

               > tr th:nth-child(7n) {
                    @extend %border-right;
               }

               > tr:first-child th {
                   padding-bottom: 0;
                   color: $alert-blue;
               }
            }

          tbody {
             tr td:nth-child(5n){
                  @extend %border-right;
             }
             tr td:nth-child(7n) {
                  @extend %border-right;
             }
          }
        }
    }


    .table-borderless tbody+tbody,
    .table-borderless td,
    .table-borderless th,
    .table-borderless thead th {
        padding: 7px;
    }


    // legend styles
    .legend {
        margin-top: 2rem;

        &__item {
            display: flex;
            margin-bottom: 1rem;
        }

        &__text {
            margin-left: .6rem;
        }
    }


    // checkboxes styles
    .checkbox {
        width: 1.5rem;
        height: 1.5rem;
        border: 2px solid #9B9B9B;
        border-radius: 3px;

        &--circle {
            border-radius: 100%;
            background-color: $green;
            border: 0;

            &--half {
                @extend .checkbox--circle;
                position: relative;
                overflow: hidden;

                &:after {
                    content: "";
                    position: absolute;
                    top: 0;
                    right: -50%;
                    height: 100%;
                    width: 100%;
                    background-color: $alert-yellow;
                }
            }

            &--center {
                @extend .checkbox--circle--half;

                &:after {
                    right: 0;
                    transform: scale(0.6);
                    border-radius: 100%;
                }
            }

            &--yellow {
                @extend .checkbox--circle;
                background-color: $alert-yellow;
            }
        }

        &--pink-border {
            border-color: $alert-pink;
        }

        &--blue {
            background-color: $alert-blue;
            border: 0;
        }

        &--triangle-down {
            background-color: $alert-pink;
            -webkit-clip-path: polygon(50% 100%, 0 0, 100% 0);
            clip-path: polygon(50% 100%, 0 0, 100% 0);
            border: 0;
            border-radius: 0;
        }

        &--triangle-right {
            background-color: $alert-pink;
            -webkit-clip-path: polygon(100% 50%, 0 100%, 0 0);
            clip-path: polygon(100% 50%, 0 100%, 0 0);
            border: 0;
            border-radius: 0;
        }

        &--half {;
            &--left,
            &--bottom {
                @extend .checkbox--circle--half;
                border-radius: 3px;

                &:after {
                    background-color: $alert-pink;
                }
            }

            &--bottom {
                &:after {
                    right: auto;
                    bottom: -50%;
                    left: 0;
                    top: auto;
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Matrix.vue